import { createContext, useContext, type ReactNode } from "react";
import type IListingCardInteractions from "./listing-card-interactions.interface";
import type { ListingCardFavoriteProps } from "./listing-card-interactions.interface";

const ListingCardContext = createContext<IListingCardInteractions | null>(null);

export function ListingCardProvider({
    interactions,
    children,
}: {
    interactions: IListingCardInteractions;
    children: ReactNode;
}) {
    return (
        <ListingCardContext value={interactions}>{children}</ListingCardContext>
    );
}

export function useListingCardPresentation() {
    const interactions = useContext(ListingCardContext);
    return {
        onCardOpened: interactions?.onCardOpened,
    };
}

export function ListingCardFavorite(props: ListingCardFavoriteProps) {
    const interactions = useContext(ListingCardContext);
    if (!interactions)
        throw new Error(
            "ListingCardProvider is required for listing favorites",
        );
    return interactions.renderFavorite(props);
}
